import React from 'react';
import { Image, Box, Text, SimpleGrid, Link, Card, CardBody, Container, Heading } from '@chakra-ui/react';
import Seo from '../../components/sections/seo';

import QuoteWithLeftMedia from '../../components/sections/quotewithleftmedia';
import QuoteWithRightMedia from '../../components/sections/quotewithrightmedia';

import timBoyle from '../../components/ui/corporateresponsibility/timBoyle.jpeg'
import abelNavarrete from '../../components/ui/corporateresponsibility/abelNavarrete.png'
import GridCard from '../../components/sections/gridcard';

import mountainHardwearCard from '../../components/ui/corporateresponsibility/2021_02_MHW_S21_day5-2488.jpeg'
import columbiaCard from '../../components/ui/corporateresponsibility/2021-02_Columbia_TK_F21_Titanium-2497.jpeg'
import pranaCard from '../../components/ui/corporateresponsibility/Image-9-opt.jpeg'
import sorelCard from '../../components/ui/corporateresponsibility/Sorel-W20_Tivoli_IV_Can_31782_R1.jpeg'

import ir2016 from '../../components/ui/corporateresponsibility/2016_impact-report_cover.png'
import ir2017 from '../../components/ui/corporateresponsibility/2017_impact-report_cover.png'
import ir2018 from '../../components/ui/corporateresponsibility/2018_impact-report_cover.png'
import ir2019 from '../../components/ui/corporateresponsibility/2019_impact-report_cover.png'
import ir2020 from '../../components/ui/corporateresponsibility/2020_impact-report_cover.png'
import ir2021 from '../../components/ui/corporateresponsibility/2021_impact-report_cover.png'
import ir2022 from '../../components/ui/corporateresponsibility/2022_impact-report_cover.png'


export default function OverviewTabPanel() {
  return (
    <Box>
      <Seo
        title="Corporate Responsibility Overview"
        description="We invest in initiatives that have a positive impact on the people we reach, the places we touch, and the products we make."
        //links={[{"rel": "canonical", "href": "https://www.columbiasportswearcompany.com/careers"}]}
      />
      <Container maxW='6xl' my={14} className='flow'>
        <Text as={'h1'} fontSize={'3xl'} fontWeight={600} py={4} sx={{'--flow-lh': 'lineHeights.10'}} fontFamily={'GerTT'}>
          AT COLUMBIA SPORTSWEAR COMPANY, WE INVEST IN INITIATIVES THAT HAVE A
          POSITIVE IMPACT ON THE PEOPLE WE REACH, THE PLACES WE TOUCH, AND THE
          PRODUCTS WE MAKE.
        </Text>
        <QuoteWithLeftMedia
            media={<Image borderRadius={10} src={timBoyle} id="timBoyleImg" />}
            speaker="– Tim Boyle, Chairman, President, & CEO"
            quote={<>“All of us want to have an impact. Every day, we make choices as to whether that impact is good or bad. At Columbia Sportswear Company, one of our core values is doing the right thing.​
              Every day, we choose to do the right thing so that our impact on our people and the planet​ is positive.
              <br /><br />
              My mother, Gert Boyle, the former Chair of our Board, used to say, 'It’s perfect. Now make it​ better.' That kind of thinking undergirds our approach to environmental, social and governance​ challenges and the impact that we have on the world. There is always room to make something better. And we are constantly evolving in our use of technologies, practices and policies to ensure that we continue to get better.” 
              </>
            }
        />
        <QuoteWithRightMedia
            media={<Image borderRadius={10} src={abelNavarrete} id="abelNavarrete" />}
            speaker="– Abel Navarrete, VP, Sustainability and Community Impact"
            quote={`"Our Corporate Responsibility team works to ensure we’re doing our part to make the outdoors accessible to all. From working with community partners to supporting programs and initiatives in the places that our products are made, we’re committed to responsible practices throughout our business."`}
        />
        <Heading>
          IMPACT REPORTS & DISCLOSURES
        </Heading>
        <SimpleGrid 
          align={'center'} 
          columns={{base: 1, md: 2}} 
          spacing={4} 
          py={4}
        >
          <Card variant='unstyled'>
            <CardBody>
              <GridCard
                title="2022 Report"
                href="https://d1io3yog0oux5.cloudfront.net/_dd23717e8b1245210477340f7aff112a/columbia/db/641/5779/pdf/2022+Impact+Report.pdf"
                backgroundImage={ir2022}
                type='is-medium two-column'
              />
              <Link display='inline-block' mt={3} href='https://d1io3yog0oux5.cloudfront.net/_dd23717e8b1245210477340f7aff112a/columbia/db/641/5780/pdf/2022+Sustainability+Accounting+Standards+Board+Index.pdf' isExternal>
                2022 SASB Summary
              </Link>
            </CardBody>
          </Card>
          <Card variant='unstyled'>
            <CardBody>
              <GridCard 
                title="2021 Report"
                href="https://s3.amazonaws.com/content.stockpr.com/columbia/db/718/5753/pdf/Columbia_CSR_RY2021_FINAL_.pdf"
                backgroundImage={ir2021}
                type='is-medium two-column'
              />
              <Link display='inline-block' mt={3} href='https://investor.columbia.com/2021_sasb_index' isExternal>
                2021 SASB Summary
              </Link>
            </CardBody>
          </Card>
        </SimpleGrid>

        <Heading>
          HISTORIC ENVIRONMENTAL, SOCIAL, & GOVERNANCE REPORTS
        </Heading>
        <SimpleGrid
          align={'center'}
          columns={{ base: 1, md: 2, lg: 3 }}
          spacing={4}
          py={4}
        >
          <Card variant='unstyled'>
            <CardBody>
              <GridCard
                title="2020 Report"
                href="https://d1io3yog0oux5.cloudfront.net/_258e51144a7b70f3536dfd884976988a/columbia/db/641/5719/pdf/2020+Corporate+Responsibility+Report.pdf"
                backgroundImage={ir2020}
                type='is-medium three-column'
              />
              <Link display='inline-block' mt={3} href='https://d1io3yog0oux5.cloudfront.net/_258e51144a7b70f3536dfd884976988a/columbia/db/641/5720/pdf/2020+Sustainability+Accounting+Standards+Board+Index.pdf' isExternal>
                2020 SASB Summary
              </Link>
            </CardBody>
          </Card>
          <Card variant='unstyled'>
            <CardBody>
              <GridCard
                title="2019 Report"
                href="https://cscworkday.blob.core.windows.net/hrforms/Recruiting/Career_Site/CR_Reports/2019_Columbia_Corp_Resp_Report.pdf"
                backgroundImage={ir2019}
                type='is-medium three-column'
              />
            </CardBody>
          </Card>
          <Card variant='unstyled'>
            <CardBody>
              <GridCard
                title="2018 Report"
                href="https://cscworkday.blob.core.windows.net/hrforms/Recruiting/Career_Site/CR_Reports/2018_Columbia_Corp_Resp_Report.pdf"
                backgroundImage={ir2018}
                type='is-medium three-column'
              />
            </CardBody>
          </Card>
          <Card variant='unstyled'>
            <CardBody>
              <GridCard
                title="2017 Report"
                href="https://cscworkday.blob.core.windows.net/hrforms/Recruiting/Career_Site/CR_Reports/2017_Columbia_Corp_Resp_Report.pdf"
                backgroundImage={ir2017}
                type='is-medium three-column'
              />
            </CardBody>
          </Card>
          <Card variant='unstyled'>
            <CardBody>
              <GridCard
                title="2016 Report"
                href="https://cscworkday.blob.core.windows.net/hrforms/Recruiting/Career_Site/CR_Reports/2016_Columbia_Corp_Resp_Report.pdf"
                backgroundImage={ir2016}
                type='is-medium three-column'
              />
            </CardBody>
          </Card>
          
        </SimpleGrid>
        <Heading>
          OUR BRAND'S INITIATIVES
        </Heading>
        <SimpleGrid align={'center'} columns={{base: 1, md: 2}} spacing={6} py={4}>
          <GridCard
            title="COLUMBIA"
            href="https://www.columbia.com/corporate-responsibility/"
            backgroundImage={columbiaCard}
            type='is-tall'
          />
          <GridCard
            title="PRANA"
            href="https://www.prana.com/sustainability.html"
            backgroundImage={pranaCard}
            type='is-tall'
          />
          <GridCard
            title="MOUNTAIN HARDWEAR"
            href="https://www.mountainhardwear.com/sustainability.html"
            backgroundImage={mountainHardwearCard}
            type='is-tall'
          />
          <GridCard
            title="SOREL"
            href="https://www.sorel.com/about-us_responsibility/"
            backgroundImage={sorelCard}
            type='is-tall'
          />
        </SimpleGrid>
      </Container>
      </Box>
  );
}
